export const GET_LIST = '@@users/GET_LIST';
export const GET_LIST_SUCCESS = '@@users/GET_LIST_SUCCESS';
export const GET_LIST_ERROR = '@@users/GET_LIST_ERROR';

export const GET_CONFIG = '@@users/GET_CONFIG';
export const GET_CONFIG_SUCCESS = '@@users/GET_CONFIG_SUCCESS';
export const GET_CONFIG_ERROR = '@@users/GET_CONFIG_ERROR';

export const GET_DATA = '@@users/GET_DATA';
export const GET_DATA_SUCCESS = '@@users/GET_DATA_SUCCESS';
export const GET_DATA_ERROR = '@@users/GET_DATA_ERROR';

export const CREATE_USER = '@@users/CREATE_USER';
export const CREATE_SUCCESS = '@@users/CREATE_SUCCESS';
export const CREATE_ERROR = '@@users/CREATE_ERROR';

export const UPDATE_DATA = '@@users/UPDATE_DATA';
export const UPDATE_DATA_SUCCESS = '@@users/UPDATE_DATA_SUCCESS';
export const UPDATE_DATA_ERROR = '@@users/UPDATE_DATA_ERROR';

export const CHANGE_STATUS = '@@users/CHANGE_STATUS';
export const CHANGE_STATUS_SUCCESS = '@@users/CHANGE_STATUS_SUCCESS';
export const CHANGE_STATUS_ERROR = '@@users/CHANGE_STATUS_ERROR';

export const COPY_CUSTOM_RATES = '@@users/COPY_CUSTOM_RATES';
export const COPY_CUSTOM_RATES_SUCCESS = '@@users/COPY_CUSTOM_RATES_SUCCESS';
export const COPY_CUSTOM_RATES_ERROR = '@@users/COPY_CUSTOM_RATES_ERROR';

export const SET_PASSWORD = '@@users/SET_PASSWORD';
export const SET_PASSWORD_SUCCESS = '@@users/SET_PASSWORD_SUCCESS';
export const SET_PASSWORD_ERROR = '@@users/SET_PASSWORD_ERROR';

export const GET_WITH_CUSTOM_RATES = '@@users/GET_WITH_CUSTOM_RATES';
export const GET_WITH_CUSTOM_RATES_SUCCESS = '@@users/GET_WITH_CUSTOM_RATES_SUCCESS';
export const GET_WITH_CUSTOM_RATES_ERROR = '@@users/GET_WITH_CUSTOM_RATES_ERROR';

export const GET_CUSTOM_RATES_FOR_USER = '@@users/GET_CUSTOM_RATES_FOR_USER';
export const GET_CUSTOM_RATES_FOR_SUCCESS = '@@users/GET_CUSTOM_RATES_FOR_SUCCESS';
export const GET_CUSTOM_RATES_FOR_ERROR = '@@users/GET_CUSTOM_RATES_FOR_ERROR';

export const GET_SERVICES_LIST = '@@users/GET_SERVICES_LIST';
export const GET_SERVICES_LIST_SUCCESS = '@@users/GET_SERVICES_LIST_SUCCESS';
export const GET_SERVICES_LIST_ERROR = '@@users/GET_SERVICES_LIST_ERROR';

export const UPDATE_CUSTOM_RATES = '@@users/UPDATE_CUSTOM_RATES';
export const UPDATE_CUSTOM_RATES_SUCCESS = '@@users/UPDATE_CUSTOM_RATES_SUCCESS';
export const UPDATE_CUSTOM_RATES_ERROR = '@@users/UPDATE_CUSTOM_RATES_ERROR';

export const GET_EXPORT_LIST = '@@users/GET_EXPORT_LIST';
export const GET_EXPORT_LIST_SUCCESS = '@@users/GET_EXPORT_LIST_SUCCESS';
export const GET_EXPORT_LIST_ERROR = '@@users/GET_EXPORT_LIST_ERROR';

export const MAKE_EXPORT = '@@users/MAKE_EXPORT';
export const MAKE_EXPORT_SUCCESS = '@@users/MAKE_EXPORT_SUCCESS';
export const MAKE_EXPORT_ERROR = '@@users/MAKE_EXPORT_ERROR';

export const GET_ACTIVITY_LOG = '@@users/GET_ACTIVITY_LOG';
export const GET_ACTIVITY_LOG_SUCCESS = '@@users/GET_ACTIVITY_LOG_SUCCESS';
export const GET_ACTIVITY_LOG_ERROR = '@@users/GET_ACTIVITY_LOG_ERROR';

export const GET_SIGNIN_HISTORY = '@@users/GET_SIGNIN_HISTORY';
export const GET_SIGNIN_HISTORY_SUCCESS = '@@users/GET_SIGNIN_HISTORY_SUCCESS';
export const GET_SIGNIN_HISTORY_ERROR = '@@users/GET_SIGNIN_HISTORY_ERROR';

export const UPDATE_DISCOUNT = '@@users/UPDATE_DISCOUNT';
export const UPDATE_DISCOUNT_SUCCESS = '@@users/UPDATE_DISCOUNT_SUCCESS';
export const UPDATE_DISCOUNT_ERROR = '@@users/UPDATE_DISCOUNT_ERROR';

export const MASS_CHANGE_STATUS = '@@users/MASS_CHANGE_STATUS';
export const MASS_CHANGE_STATUS_SUCCESS = '@@users/MASS_CHANGE_STATUS_SUCCESS';
export const MASS_CHANGE_STATUS_ERROR = '@@users/MASS_CHANGE_STATUS_ERROR';

export const MASS_RESET_RATES = '@@users/MASS_RESET_RATES';
export const MASS_RESET_RATES_SUCCESS = '@@users/MASS_RESET_RATES_SUCCESS';
export const MASS_RESET_RATES_ERROR = '@@users/MASS_RESET_RATES_ERROR';

export const MASS_COPY_RATES = '@@users/MASS_COPY_RATES';
export const MASS_COPY_RATES_SUCCESS = '@@users/MASS_COPY_RATES_SUCCESS';
export const MASS_COPY_RATES_ERROR = '@@users/MASS_COPY_RATES_ERROR';

export const GET_TOTALS = '@@users/GET_TOTALS';
export const GET_TOTALS_SUCCESS = '@@users/GET_TOTALS_SUCCESS';
export const GET_TOTALS_ERROR = '@@users/GET_TOTALS_ERROR';

export const CLEAR_DATA = '@@users/CLEAR_DATA';
